import { useEffect, useState } from 'react';
import { QUARTER } from '../shared/q3';

const Q_START = new Date(QUARTER.start).getTime();
const Q_END = new Date(QUARTER.end).getTime();

export interface QuarterClock {
  /** Share of the quarter elapsed, 0–1: where an on-pace RM's progress should be. */
  pace: number;
}

function read(): QuarterClock {
  return { pace: Math.min(Math.max((Date.now() - Q_START) / (Q_END - Q_START), 0), 1) };
}

/** Pace moves slowly, so this refreshes every 30s; the per-second countdown lives in Countdown. */
export function useQuarterClock(): QuarterClock {
  const [clock, setClock] = useState(read);
  useEffect(() => {
    const id = setInterval(() => setClock(read()), 30_000);
    return () => clearInterval(id);
  }, []);
  return clock;
}
